@import '~style-sheet-helpers/core.less';
@import (reference) '../constants/screen-width-breakpoints.module.less';
@import (reference) '../constants/spacing.module.less';

.country-dropdown {
  width: 100%;

  & button {
    margin-top: var(--country-dropdown-button-margin-top, 4px);
  }

  .country-toggler {
    padding: @space-4 @space-8;
  }
}

.country-label {
  font-weight: 400;
  font-size: 12px;
}

.country-input {
  border: 0;
  padding: 0;
  height: 22px;

  @media @mobile {
    font-size: 16px;
  }
}
